import type { ReactElement } from "react";
import type { ParseKeys } from "i18next";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import HistoryIcon from "@mui/icons-material/History";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { ROUTES } from "../../route_paths";

/** One section of the account space: where it lives, its label key and its icon. */
export interface AccountSection {
  path: string;
  labelKey: ParseKeys;
  icon: ReactElement;
}

/** The sections of the account space, in navigation order. A section appears once it is built. */
export const ACCOUNT_SECTIONS: AccountSection[] = [
  {
    path: ROUTES.account.profile.path(),
    labelKey: "account.sections.profile",
    icon: <PersonOutlineIcon />,
  },
  {
    path: ROUTES.account.verifications.path(),
    labelKey: "account.sections.verifications",
    icon: <HistoryIcon />,
  },
  {
    path: ROUTES.account.feedback.path(),
    labelKey: "account.sections.feedback",
    icon: <ChatBubbleOutlineIcon />,
  },
];
